(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/products/assets/javascripts/products.js') >= 0) return;  svs.modules.push('/components/components/products/assets/javascripts/products.js');
"use strict";

(svs => {
  svs.components = svs.components || {};
  svs.components.products = svs.components.products || (() => {
    function init() {
      $('.main-content').on('click', '.js-product-link', e => {
        e.preventDefault();
        const productName = $(e.currentTarget).find('[itemprop=name]').text();
        const productUrl = $(e.currentTarget).attr('href');
        const evt = {
          category: 'Navigation',
          action: 'Game Chooser',
          opt_label: productName
        };
        svs.components.analytics.trackEvent(evt, () => {
          location.href = productUrl;
        });
      });
    }
    init();
  })();
})(svs);

 })(window);